import { api } from '@/helpers/api'
import useNotification from '@/composables/useNotification.js'

const URLS = {
    xhr: {
        mutate: {
            offer: '/api/event/apply'
        }
    }
}
export const useDirectBookingMakeOffer = (userData, event, load) => {
    const { notification } = useNotification()

    async function makeOffer() {
        if (event.value !== null) {
            try {
                load.value = true
                const data = _prepData(userData.value.makeOffer)

                await api({
                    method: 'post',
                    url: `${URLS.xhr.mutate.offer}/${event.value}`,
                    data: {
                        ...data,
                        artist_id: userData.value.artistInfo.id
                    }
                })
                return true
            } catch {
                return false
            } finally {
                load.value = false
            }
        } else {
            notification('error', 'Make Offer failed.')
            return false
        }
    }

    function _prepData(data) {
        data = Object.entries(data).reduce((prev, [key, val]) => {
            switch (key) {
                case 'counter_offer_duration':
                    return {
                        ...prev,
                        [key]: parseFloat((val / 60).toFixed(2))
                    }
                case 'start_avail':
                    prev
                    return {
                        ...prev,
                        [key]: `${data.start_avail_time} ${data.start_avail_format}`
                    }
                case 'start_avail_time':
                case 'start_avail_format':
                    return prev
                default:
                    return {
                        ...prev,
                        [key]: val
                    }
            }
        }, {})

        return data
    }

    return {
        makeOffer
    }
}
